














import Component from "vue-class-component";
import { BaseRootPageComponent } from "../BaseRootPageComponent";
import { updateGTMGlobalVariables } from "@/utils/gtm";

@Component
export default class Error extends BaseRootPageComponent {
  created() {
    this.setTitle("Unknown Error");

    // updateGTMGlobalVariables(this);
  }
}
